class ErrorForTranslation extends Error {
	constructor(keyForTranslation, error = '', params = {}) {
		super(error ? keyForTranslation + ' ' + error : keyForTranslation)
		this.name = 'ErrorForTranslation'
		this.errorMsg = error
		this.key = keyForTranslation
		this.params = params
	}
}

const getTranslatedMessage = (err, translateFunc) => {
	return translateFunc(err.key, err.params) + err.errorMsg
}

const getErrorMessage = (err, translateFunc) => {
	if (err instanceof String) {
		return err
	} else if (err instanceof Error) {
		if (err.name === 'ErrorForTranslation') {
			return getTranslatedMessage(err, translateFunc)
		} else {
			return err.message
		}
	} else {
		console.log('Unknown error object', err)
		return ''
	}
}

export { ErrorForTranslation, getErrorMessage }



// WEBPACK FOOTER //
// ./src/common/ErrorForTranslation.js